<template lang="pug">
div
  app-modal-cruzamento-camada(
    v-if="showModalCamadas"
    @close="visualizarCruzamentoCamadas"
    :cruzamento="cruzamentoCamada.json"
  )
  app-divider(label="Georreferenciamento", v-if="isGeoBeneficiario")
  .pad
    div(v-if="localizacoes && localizacoes.length")
      app-resumo-mapa(
        :key="mapaKey"
        :localizacoes="localizacoes",
        :id-mapa="idMapa",
        :isVisualizarCadastro="true"
      )
      div.btn(v-if="idProcesso")
        el-button(
          @click="downloadShape"
        )
          i.fal.fa-download
          | &nbsp Download do shapefile
        el-button(
          @click="visualizarCruzamentoCamadas",
          v-if="cruzamentoCamada"
        )
          i.fal.fa-eye
          | &nbsp Visualizar cruzamentos
    div(v-else)
      span Não foi informado nenhum dado durante o cadastro.
    informacoes-responsavel-geo(
      v-if="geo.possuiGeorreferenciamento === 'POSSUI'"
      :responsavel="geo.responsavel",
      :possuiCredenciadoGeo="possuiCredenciadoGeo",
      :compararResumoGeo="compararResumoGeo"
    )

    app-resumo-documentos(
      :documentos="geo.documentos",
      v-if="exibeDocumentos",
      codigoCadastro="georreferenciamento",
      :idCadastro="idCadastro",
      :addMarginTop="false"
    )
</template>

<script>
import AppDivider from '../AppDivider'
import { mapActions } from 'vuex'
import AppResumoDocumentos from './AppResumoDocumentos'
import InformacoesResponsavelGeo from '../informacoesCadastro/InformacoesResponsavelGeo'
import AppResumoMapa from './AppResumoMapa'
import AppDisplay from '@/components/AppDisplay'
import AppModalCruzamentoCamada from '@/components/AppModalCruzamentoCamada'

export default {
  components: {
    AppDivider,
    AppResumoDocumentos,
    AppResumoMapa,
    AppDisplay,
    InformacoesResponsavelGeo,
    AppModalCruzamentoCamada
  },

  props: {
    geo: {
      type: Object,
      required: true
    },
    localizacao: {
      type: Object,
      required: false
    },
    cruzamentoCamada: {
      type: Object,
      required: false
    },
    idMapa: {
      type: String,
      default: 'mapaResumo'
    },
    exibeDocumentos: {
      type: Boolean,
      default: true
    },
    isVisualizarCadastro: {
      type: Boolean,
      default: false
    },

    isGeoBeneficiario: {
      type: Boolean,
      default: true
    },
    idCadastro: {
      required: true
    },
    isCadastroOff: {
      type: Boolean,
      default: false
    },
    idProcesso: {
      type: Number,
      required: false
    },
    showMapa: {
      type: Boolean,
      default: true
    },
    possuiCredenciadoGeo: {
      type: Boolean
    },
    compararResumoGeo: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      showModalCamadas: false,
      mapaKey: 1
    }
  },

  computed: {
    localizacoes () {
      return this.localizacao ? [this.localizacao] : (this.isCadastroOff ? this.extractCoordinates(this.geo.localizacoes) : this.geo.localizacoes)
    }
  },

  methods: {
    ...mapActions({
      shape: 'processo/shape'
    }),

    extractCoordinates (localizacoes) {
      return localizacoes.map(loc => loc.geometry)
    },

    visualizarCruzamentoCamadas () {
      this.showModalCamadas = !this.showModalCamadas
    },

    async downloadShape () {
      await this.shape(this.idProcesso)
    },

    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    }
  },

  watch: {
    localizacoes: {
      handler (val) {
        this.mapaKey += 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pad {
  padding: 15px 5px;
}

.pad5 {
  padding: 25px 10px;
}

.margin-top {
  margin-top:25px;
}

.btn {
  margin-top: 12px;
  text-align: right;
}

.label {
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoGeo.vue